import React from "react";

export default function CsImpact() {
    return (
        <div className="cs-impact-section  section-gap">
            <div className="container">
                <div className="cs-impact-content">
                    <h3>Impact</h3>
                    <p>Our cross-functional product team devised a product strategy, roadmap, and launched the first version of the new website in less than 3-months. </p>

                    <p>We picked cutting-edge open source technologies and agile practices to deliver a strong technical and process-based foundation that allowed Harris Teeter to grow their e-commerce presence by leaps and bounds.</p>
                </div>
            </div>
        </div>
    );
}